import { createContext, useContext, useEffect, useState } from "react";
import { AuthAPI } from "../lib/api";

const AuthContext = createContext(null);

const TOKEN_KEY = "heo_token";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, obj=logged in

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setUser(null);
      return;
    }
    AuthAPI.me()
      .then((u) => setUser(u))
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const { access_token, user: u } = await AuthAPI.login(email, password);
    localStorage.setItem(TOKEN_KEY, access_token);
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
    window.location.href = "/login";
  };

  const refreshMe = async () => {
    try {
      const u = await AuthAPI.me();
      setUser(u);
    } catch {
      /* ignore */
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
